import { CMFilesUploadPresenter } from './FilesUploadPresenter';
export class CMFilesUploadManager {
    constructor(params) {
        this._presenters = [];
        this.cm = params.cm;
        this.uploadHandler = params.uploadHandler;
        this.reactRenderer = params.reactRenderer;
        this.needDimmensionsForImages = params.needDimmensionsForImages;
    }
    upload(files) {
        this._presenters.push(new CMFilesUploadPresenter(this).run(files));
    }
    destroy() {
        for (const presenter of this._presenters) {
            presenter.destroy();
        }
        this._presenters.length = 0;
    }
    onAllSettled(presenter) {
        presenter.destroy();
        const index = this._presenters.indexOf(presenter);
        if (index >= 0) {
            this._presenters.splice(index, 1);
        }
    }
}
